import { CMS_GET, CMS_UPDATE} from "../../Constants/CmsConstants";
import { createGetDataReducer } from "./CommonReducer";

export const CmsGetReducer = createGetDataReducer( CMS_GET );
export const CmsDetailReducer = createGetDataReducer( CMS_GET );
export const CmsUpdateReducer = createGetDataReducer( CMS_UPDATE );


